import redirectInterceptor from "@/interceptors/redirect_interceptor";

export class ProfilesService {
  constructor(baseUrl, kdProfilesFromJsonMapper, kdProfileCreateDataToJson, kdProfileDataToJson) {
    this.kdProfilesFromJsonMapper = kdProfilesFromJsonMapper;
    this.kdProfileCreateDataToJson = kdProfileCreateDataToJson;
    this.kdProfileDataToJson = kdProfileDataToJson;
    this.baseUrl = baseUrl;

  }

  async getMany(accessToken, vesselName) {
    try {
      const response = await redirectInterceptor.get(
        `${this.baseUrl}/kdiagram/vessel/${vesselName}/profiles`,
        {
          headers: {
            "Authorization": `${accessToken}`,
          },
        }
      );
      const result = response.data.map((datum) => this.kdProfilesFromJsonMapper(datum));
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createOne(accessToken, vesselName, profile) {
    try {
      const requestParams = {
        method: "POST",
        url: `${this.baseUrl}/kdiagram/vessel/${vesselName}/profiles`,
        headers: {
          accept: "application/json",
          "Content-type": "application/json",
          "Authorization": `${accessToken}`,
        },
        data: this.kdProfileCreateDataToJson(profile)
      };
      const response = await redirectInterceptor.request(requestParams);
      const result = response.data.map((datum) => this.kdProfilesFromJsonMapper(datum));
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateOne(accessToken, vesselName, profile) {
    const requestParams = {
      method: "PUT",
      url: `${this.baseUrl}/kdiagram/vessel/${vesselName}/profiles/${profile.id}`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `${accessToken}`,
      },
      data: this.kdProfileDataToJson(profile)
    };

    try {
      const response = await redirectInterceptor.request(requestParams);
      const result = this.kdProfilesFromJsonMapper(response.data);
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteOne(accessToken, vesselName, profileId) {
    try {
      const response = await redirectInterceptor.delete(
        `${this.baseUrl}/kdiagram/vessel/${vesselName}/profiles/${profileId}`,
        {
          headers: {
            "Authorization": `${accessToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
